import React from "react"
import Banner from "../../containers/banner"
import About from "../../containers/about"
import Layout from "../../containers/layout";
import { Container, Row, Col } from 'reactstrap';
import { Titlespan2 } from '../../components/title/index';
import AfterBanner from '../../containers/after-banner';

const IndexPage = () => {
    return (
        <Layout>
            <Banner ChangeClass={'demo1'} title="Industry Sectors" body={(
                <>
                    <h3>Telecommunications</h3>
                    <p><a className="text-white" href="/sectors">Back to sectors</a></p>
                </>
            )}/>
            <AfterBanner size={9} title="" subtitle="Overview">
            <p>As profit decline in Telecommunication industries, mobile and fixed services converge, and business boundaries in the ecosystem are becoming thin. We serve Telco’s in Africa & Latin America, helping them to better understand their customers, build superior networks, find a sustainable path to growth and optimise cost while maintaining a high-performance organization.</p>
            <p>We help:</p>
            <ul>
                <li>Existing Telco’s transform from legacy to digital footprints with better margins and valuation as an end game.  </li>
            </ul>

            </AfterBanner>
            <About width={8} title={'Expertise'} body={(
                <div className="text-white">
                    <p className="text-white">We have worked with 85% of the Africa’s top telecom operators and 80% of the largest telecom equipment companies. We have our teams of consultants widespread and placed in both emerging &amp; matured markets. </p>
                    <p className="text-white">We are passionate about opportunities to transform our client’s businesses, and our consultants &amp; experts provide critical support and expertise to help clients achieve results. We focus on developing realistic strategies to address our clients' most critical challenges.</p>
                    <p className="text-white">We share our clients' passion for results and work to ensure they can reach their full potential through our unique approach of change management, risk &amp; issue management, performance &amp; Project management. </p>

                    <p className="text-white">Focus Area:</p>
                    <table className="table text-white" style={{ marginTop: '60px'}}>
                        <tbody>
                            <tr>
                                <td>
                                    <strong>Growth</strong>: We act as trusted partners, supporting our clients in making strategic decisions about the future ecosystem, how to benefit from new delivery models and new opportunities to monetize, and how to increase revenue pools.
                                </td>
                                <td>
                                    <strong>Transformation</strong>: We lead cross-functional efforts to alter a business's financial, operational and strategic directions to produce game-changing results.
                                </td>
                                <td>
                                    <strong>Digital</strong>: We help Telco’s use digital and analytics to deliver on core strategy, customer excellence and optimise operations, leading to increased revenue.
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Organizational effectiveness</strong>: An effective organization can give companies the edge that sets them apart from the competition. We work with you to ensure that your organization is aligned and set up to deliver on the objectives.
                                </td>
                                <td>
                                    <strong>Simplification</strong>: We work to improve efficiency and effectiveness, so the companies can better serve their customers. Our experts in Information Technology and Performance Improvement work to develop agile technology organizations and streamlined back-end processes that please customers and generate savings.
                                </td>
                                <td>
                                    <strong>Customer experience</strong>: We help companies develop unparalleled customer strategies. Our expertise with the industry allows us to help companies increase customer engagement and retention while ensuring optimal service delivery, segmentation and pricing.
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            )} />

            <section className="text-left" >
                <Container>
                    <div className="main-title-wrapper text-left">
                    <Col xs={12} lg={{ size: 6}}>
                        <Titlespan2
                                Class="sitemain-subtitle"
                                Name="View"
                                Label=""
                            />

                        <p>Our Business &amp; Technology Consulting services are designed to ensure that service providers remain competitive in aggressive markets, address customer demands, develop future-proof strategies and generate new revenue while reducing costs.</p>
                        <p>We apply a holistic approach to business transformation projects, providing business and technology services that caters all program stages and targets from both a system and business value perspective. Our Professional teams are seasoned to help service providers strengthen their competitive position with strategy, solution roadmap design, business process improvements, customer experience and cost-centric improvements that help maximize the business value.</p>
                        <p>We have the expertise—and <strong>a global network of partners and senior consultants</strong> with extensive telecommunications &amp; Business experience—to help companies address the most critical issues:</p>
                    </Col>
                    <Col xs={12} style={{ marginTop: '60px'}}>

                        <table className="table">
                        <tbody>
                            <tr>
                                <td>
                                <strong>Uncertainty</strong>: Profit pools are declining, mobile and fixed services are converging, and business boundaries are becoming thin. Telco’s must decide their action plan and path in industry consolidation on the major ongoing technological and infrastructural transformation.
                                </td>
                                <td>
                                <strong>Competitive advantage</strong>: Telco’s need to have a paradigm shift on the perception of their networks' value to shift the customer focus from price alone. Need for innovative products and services and enhanced capabilities that create a more sophisticated approach to pricing and selling.
                                </td>
                                <td>
                                <strong>Network Infrastructure:</strong>
                                Telco’s need to invest wisely in their infrastructure to meet up the data rich demand and know precisely where their investments will have the biggest impact on customer experience
                                </td>
                            </tr>
                            <tr>
                                <td>
                                <strong>Simplify</strong>: Telco’s need to manage complexity on - complex bundles of products and services, devices, operating systems and applications. They need flexibility and efficiency to ensure smooth operations and the organization achieves its full potential.
                                </td>
                                <td>
                                <strong>Customer Experience</strong>: Deliver personalised experience along with privacy concerns are paramount to customers and business.
                                </td>
                                <td>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </Col>
                    </div>
                </Container>
            </section>
        </Layout>
    )
}

export default IndexPage
